import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  helpContentText: {
    defaultMessage:
      'Upload a CSV file to your inventory records. Need help formatting? <file>Download our sample CSV file</file> or <helpLink>learn more about importing a CSV.</helpLink>',
    id: 'THArN4',
    description: 'Inventory Import help content text',
  },
  uploadFile: {
    id: '8cjYM6',
    defaultMessage: 'Upload File',
    description: 'Title for the first step of the import process',
  },
  selectInventoryWarehouse: {
    id: 'XIKPC5',
    defaultMessage: 'Select Inventory Warehouse',
    description: 'Label for the dropdown to select the inventory warehouse',
  },
  selectInventoryWarehouseHeader: {
    id: 'ysC9cl',
    defaultMessage: 'Select Warehouse to Apply Import To',
    description: 'Label for the header to select the inventory warehouse',
  },
  selectStockImportTypeHeader: {
    id: 'XS8Agt',
    defaultMessage: 'When Importing Stock Counts',
    description: 'Label for the header to select the stock import type',
  },
  selectStockImportType: {
    id: 'u2FkiY',
    defaultMessage: 'Select Stock Import Type',
    description: 'Label for the dropdown to select the stock import type',
  },
  addToCurrentStockCounts: {
    id: '27rPT8',
    defaultMessage: 'Add to current stock counts',
    description: 'Label for dropdown item to add to current stock counts',
  },
  overwriteCurrentStockCounts: {
    id: 'VGncbx',
    defaultMessage: 'Overwrite current stock counts',
    description: 'Label for dropdown item to overwrite current stock counts',
  },
});
